import approximateNumber from 'approximate-number';
import number from './number';
import {
    dateLocal, dateTime, dateUTC, time, dateFormat, tzDate,
} from './date';
import bytes from './bytes';
import pan from './pan-format';
import {formatBoolean as boolean, formatOnOff as onOff, formatYesNo as yesNo} from './boolean';
import monetize from '@/common/helpers/monetize';

const format = {
    approximateNumber,
    time,
    dateTime,
    dateUTC,
    dateLocal,
    dateFormat,
    tzDate,
    number,
    bytes,
    pan,
    boolean,
    onOff,
    yesNo,
    monetize,
};

export default format;
